import type { DisabledReason } from './AIButton.types';

type TooltipKey =
  | 'components.aiButton.tooltipNoNetwork'
  | 'components.aiButton.tooltipUnavailable'
  | 'components.aiButton.tooltipDrawerOpen';

const TOOLTIP_KEYS: Record<DisabledReason, TooltipKey> = {
  noNetwork: 'components.aiButton.tooltipNoNetwork',
  aiCapabilityUnavailable: 'components.aiButton.tooltipUnavailable',
  drawerOpen: 'components.aiButton.tooltipDrawerOpen',
};

export const getTooltipKey = (disabledReason: DisabledReason | undefined): TooltipKey => {
  if (disabledReason === 'noNetwork') {
    return TOOLTIP_KEYS.noNetwork;
  }

  if (disabledReason === 'drawerOpen') {
    return TOOLTIP_KEYS.drawerOpen;
  }

  return TOOLTIP_KEYS.aiCapabilityUnavailable;
};

interface ButtonPosition {
  bottom: number;
  right: number;
  left: number;
}

export const getButtonStyle = (position: ButtonPosition): React.CSSProperties => {
  const useLeftAnchor = position.left < position.right;

  if (useLeftAnchor) {
    return { bottom: position.bottom, left: position.left, right: 'auto' };
  }

  return { bottom: position.bottom, right: position.right, left: 'auto' };
};
